import React from "react";
import styled from "styled-components";

import Select from '@material-ui/core/Select';
import { SelectProps } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Button, { ButtonProps } from '@material-ui/core/Button';

import { Tag, DeleteIconButton, Flex } from '../styles/global'
import deleteIcon from "../assets/delete.svg";

import { Input } from './Input'

import { Intervention, APIIntervention } from "../models"

interface Props {
  title: string;
  currentInterventions: Intervention[];
  allInterventions: APIIntervention[]
  setValue: (value: any) => void;
}

const createIntervention = (interventionName: string, interventionParameters: string) =>
  ({ name: interventionName, parameters: interventionParameters })
export const Interventions = ({ title, currentInterventions, allInterventions, setValue }: Props) => {
  const remainingInterventions = allInterventions.filter(intervention =>
    currentInterventions.every(currentIntervention => currentIntervention.name !== intervention.name));

  return (
    <InterventionsWrapper>
      <Tag>{title}</Tag>
      {currentInterventions.map((intervention: any, index: number) => (
        <InterventionWrapper key={intervention.name + index} alignItems="center">
          <StyledSelect
            labelId="intervention-label"
            id="intervention-select"
            variant="outlined"
            MenuProps={{ getContentAnchorEl: null }}
            value={intervention ?? ""}
            onChange={(e) => {
              const { value }: { value: any } = e.target;
              console.log(intervention)
              let newInterventions = [...currentInterventions]
              newInterventions[index].name = value.name
              newInterventions[index].parameters = value.parameters
              setValue(newInterventions);
            }}
          >
            <MenuItem key={intervention.id} value={intervention}>{intervention.name}</MenuItem>
            {remainingInterventions.map((value) => (
              <MenuItem key={value.name} value={value as any}>{value.name}</MenuItem>
            ))}
          </StyledSelect>
          <Input
            //title="Parameters"
            required
            requiredString="Parameters required."
            setValue={(value: string) => {
              let newInterventions = [...currentInterventions]
              newInterventions[index].parameters = value
              setValue(newInterventions);
            }}
            value={intervention.parameters}
            multiline
            minRows={4}
            style={{
              width: "50%",
              padding: "10px",
            }}
          />
          {allInterventions.length >= 1 &&
            <DeleteIconButton
              style={{ marginLeft: '12px' }}
              onClick={() => {
                let newInterventions = [...currentInterventions]
                newInterventions.splice(index, 1)
                setValue(newInterventions);
              }}
            >
              <img src={deleteIcon} style={{ height: 24 }} alt="delete" />
            </DeleteIconButton>
          }
        </InterventionWrapper>
      ))}
      <StyledButton
        size="large"
        variant="contained"
        disabled={remainingInterventions.length === 0}
        disableElevation
        onClick={() => {
          let newInterventions = [...currentInterventions]
          let newIntervention =
            createIntervention(remainingInterventions[0].name, remainingInterventions[0].parameters);
          newInterventions.push(newIntervention)
          setValue(newInterventions);
        }}
      >
        Add Intervention
      </StyledButton>
    </InterventionsWrapper>
  );
};


const InterventionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
`
const StyledButton = styled(Button) <ButtonProps>`
  && {
    max-width: 280px;
    margin-top: 12px;
    margin-bottom: 32px;
  }
` as typeof Button;

const StyledSelect = styled((props: SelectProps) => <Select {...props} />)`
  width: 180px;
`;

const InterventionWrapper = styled(Flex)`
  padding: 12px 0px;
  > * {
    margin-right: 24px !important;
  }
`
